module.exports = __webpack_public_path__ + "static/media/school.002ddebd.png";